import { LOCAL_SEND } from '../shared/localSend';
import { DYNAMIC_BUTTON_FIELDS, MEDIA_HEADER_KINDS } from '../shared/templateModel';

// What the Standard panel has fields for. A button_type of CATALOG, MPM, FLOW, ORDER_DETAILS, REQUEST_CONTACT_INFO or
// PASSKEY, a header type outside these, or a button of another kind keeps the template on the shared component's form.
// An empty or missing button_type is a template with no button.
const URL_TYPES = ['STATIC', ...Object.keys(DYNAMIC_BUTTON_FIELDS)];
const BUTTON_TYPES = ['NONE', '', 'STATIC', ...Object.keys(DYNAMIC_BUTTON_FIELDS), 'COMPLEX', 'LTO'];
const HEADER_TYPES = ['TEXT', ...MEDIA_HEADER_KINDS];
const BUTTON_KINDS = ['QUICK_REPLY', 'URL', 'PHONE_NUMBER', 'COPY_CODE', 'VOICE_CALL'];

/**
 * True when the Standard panel can be the whole form for the template. Anything else stays on the shared component's
 * form (see ../registry.js). A kind whose LOCAL_SEND flag is off is never supported here: it is the shared component's.
 * @param {object} [details] - a mapTemplate() row's `.details`
 * @returns {boolean}
 */
export function isLocalFormSupported(details) {
  const d = details ?? {};
  const buttons = Array.isArray(d.buttons) ? d.buttons : [];
  const handedBack = (d.type === 'GIF' && !LOCAL_SEND.gif)
    || (d.type === 'LOCATION' && !LOCAL_SEND.location)
    || (d.button_type === 'LTO' && !LOCAL_SEND.lto)
    || (!LOCAL_SEND.voiceCall && buttons.some((button) => button?.type === 'VOICE_CALL'));
  return !handedBack
    && BUTTON_TYPES.includes(d.button_type ?? 'NONE')
    && HEADER_TYPES.includes(d.type)
    && buttons.every((button) => BUTTON_KINDS.includes(button?.type)
      && (button.type !== 'URL' || URL_TYPES.includes(button.urlType)));
}
